import React, { useMemo, useEffect } from 'react';
import { InputLabel, Select, MenuItem, makeStyles } from '@material-ui/core';
import { Controller } from 'react-hook-form';
import { ISelectOptions } from '../interfaces/IDynamicFormRow';
import ICommonFormProps from '../interfaces/ICommonFormProps';

const usePlaceholderStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& input': {
            opacity: 'unset!important',
            border: 0,
            background: 'transparent',
            outline: 'unset',
            bottom: 'unset',
            height: 'auto',
            padding: '1rem',
            overflow: 'hidden',
            minHeight: '1.1876em',
            whiteSpace: 'nowrap',
            borderRadius: '8px',
            textOverflow: 'ellipsis',
            backgroundColor: '#F3F4F9',
            '&::placeholder': {
                color: '#AAB6D3',
            },
        },
    },
}));

/**Form select component pass through the select options in the formProps*/
const FormSelect = (props: ICommonFormProps) => {
    const classes = usePlaceholderStyles();
    const options = useMemo(() => {
        const options: ISelectOptions[] = (props?.formProps?.selectOptions || []) as ISelectOptions[];
        return options.map((option: ISelectOptions) => {
            return (
                <MenuItem key={option.value} value={option.value}>
                    {option.name}
                </MenuItem>
            );
        });
    }, [props?.formProps?.selectOptions]);

    useEffect(() => {
        if (props.setValue && props?.formProps?.update) {
            props.setValue(props.keyName, '');
        }
        // eslint-disable-next-line
    }, [props?.formProps?.update]);

    useEffect(() => {
        //needs to remove tabindex to prevent auto focus
        const element = document.getElementById(`mui-component-select-${props.keyName}`);
        if (element) {
            element.removeAttribute('tabindex');
        }
    });

    return (
        <div data-component-name={props.keyName} style={{ width: '100%' }}>
            <InputLabel required={props.inputProperties?.required} id="selformselect" style={{ float: 'left' }}>
                {props.label}
            </InputLabel>
            <Controller
                render={({ field: { onChange, value, name, ref }, fieldState, formState }) => {
                    return (
                        <Select
                            inputProps={{
                                'data-testid': 'form-select',
                            }}
                            inputRef={ref}
                            style={{ width: '100%' }}
                            name={name}
                            value={value}
                            placeholder={props.inputProperties?.placeholder}
                            required={props.inputProperties?.required}
                            onChange={onChange}
                            disableUnderline
                            disabled={props.disabled}
                            className={!value && props?.inputProperties?.placeholder ? classes.root : ''}
                        >
                            {options}
                        </Select>
                    );
                }}
                control={props.control}
                defaultValue={props.value}
                name={props.keyName}
                rules={props.registerOptions}
            />
        </div>
    );
};

export default FormSelect;
